import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// import { Switch, Route } from 'react-router'
// import history from "./history";

//WEBSITE pages:
import home from "./WEBSITE/pages/home";
import contact from "./WEBSITE/pages/contact";
// import projects from './WEBSITE/pages/projects';
import produces from "./WEBSITE/pages/produces";
import produceDetail from "./WEBSITE/pages/produceDetail";
import News from "./WEBSITE/pages/news";
import newsDetail from "./WEBSITE/pages/newsDetail";
import about from "./WEBSITE/pages/about";
import consult from "./WEBSITE/pages/consult";

//PANEL pages:
// import login from './PANEL/pages/login';
// import Dashboard from './PANEL/pages/dashboard';

//Other Pages:
import NotFound from "./WEBSITE/pages/notFound";
import test from "./test";

const Routes = () => {
  return (
    // <Router basename={getBasename()} history={history}>

    <Switch>
      {/* WEBSITE Routes: */}
      <Route path="/" component={home} exact />
      <Route path="/contact" component={contact} />
      <Route path="/consult" component={consult} />
      {/* <Route path="/projects" component={projects} /> */}
      <Route path="/produces" component={produces} />
      <Route path="/produce/:id" component={produceDetail} />
      <Route path="/news" component={News} exact />

      {/* <Route
                exact
                path="/news"
                render={({ history }) => (
                    <News history={history} />

                )}
            />  */}

      <Route
        path="/news/:id/"
        component={newsDetail}

        // render={({ match }) => {
        //     return match ? <newsDetail match={match} /> : <NotFound />
        // }}
      />

      <Route path="/about" component={about} />

      {/* PANEL Routes: */}
      {/* <Route path="/login" component={login} exact />
            <Route
                path="/dashboard"
                render={() => {
                    if (localStorage.getItem('token')) return <Dashboard />;
                    else return <Redirect to="/login" />;
                }}
            /> */}

      <Route path="/test" component={test} />
      <Route component={NotFound} />
    </Switch>
    // </Router>
  );
};

export default Routes;
